import { Button, ButtonWrapper } from "./styled";

import React from "react";

interface IpidListProps {
  readonly link: string;
  readonly text: string;
  readonly trackId?: string;
  readonly className?: string;
  readonly isOnColoredBackground?: boolean;
}

export const DownloadButton = ({
  link,
  text,
  trackId,
  className,
  isOnColoredBackground,
}: IpidListProps): React.ReactElement => (
  <ButtonWrapper
    className={className}
    isOnColoredBackground={isOnColoredBackground}
  >
    <Button
      forwardedAs="a"
      type="button"
      iconLeft="download"
      variant="text"
      data-trackid={trackId ?? className}
      id={trackId}
      href={link}
      target="_blank"
      rel="noreferrer"
    >
      {text}
    </Button>
  </ButtonWrapper>
);
